'use client';

import { c as _c } from "react/compiler-runtime";
import ErrorTemplate from '@/components/errorTemplate/ErrorTemplate';
export default function ErrorPage(t0) {
  const $ = _c(1);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ErrorTemplate title={"\uC77C\uC2DC\uC801\uC778 \uC7A5\uC560\uB85C\n\uC11C\uBE44\uC2A4\uC640 \uC5F0\uACB0\uB418\uC9C0 \uBABB\uD588\uC5B4\uC694"} description={"\uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  return t1;
}